/*
 based on uppie.js v1.1.2 | (c) silverwind
 */
/**
 * @name FileSystemEntry
 * @typedef FileSystemEntry
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry}
 */
/**
 * @param {DataTransfer} dt
 * @param {function} cb
 */
export function readDataTransferDirectories (dt, cb) {
  const items = dt.items
  if (!items || !items.length || !('webkitGetAsEntry' in items[0])) {
    return null
  }
  const files = []
  const rootPromises = []

  /**
   * @param {FileSystemEntry} entry
   * @param reader
   * @param oldEntries
   * @param cb
   */
  function readEntries (entry, reader, oldEntries, cb) {
    const dirReader = reader || entry.createReader()
    dirReader.readEntries(function (entries) {
      const newEntries = oldEntries ? oldEntries.concat(entries) : entries
      if (entries.length) {
        setTimeout(readEntries.bind(null, entry, dirReader, newEntries, cb), 0)
      } else {
        cb(newEntries)
      }
    })
  }

  /**
   * @param {FileSystemEntry} entry
   * @param {string|null} path
   * @param {function} resolve
   */
  function readDirectory (entry, path, resolve) {
    if (!path) path = entry.name
    readEntries(entry, 0, 0, function (entries) {
      const promises = []
      entries.forEach(function (entry) {
        promises.push(new Promise(function (resolve) {
          if (entry.isFile) {
            entry.file(function (file) {
              const p = path + '/' + file.name
              files.push({ file, path: p })
              resolve()
            }, resolve.bind())
          } else readDirectory(entry, path + '/' + entry.name, resolve)
        }))
      })
      Promise.all(promises).then(resolve.bind())
    })
  }

  Array.from(items).forEach(item => {
    const getEntry = item.webkitGetAsEntry || item.getAsEntry
    if (!getEntry) return
    const entry = item.webkitGetAsEntry()
    if (entry) {
      rootPromises.push(new Promise(resolve => {
        if (entry.isFile) {
          entry.file(file => {
            files.push({ file, path: file.name })
            resolve()
          }, resolve.bind())
        } else if (entry.isDirectory) {
          readDirectory(entry, null, resolve)
        }
      }))
    }
  })
  Promise.all(rootPromises).then(cb.bind(null, files))
}
